import React, { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { dispatcher } from 'dispatcher';
import { Icon } from 'js/components/common/Icon';
import { useAppSelector, usePageSelector, useUserSelector } from 'js/store/hooks';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { Logo } from '@core/js/components/main/DefaultHeader/components/Logo';
import { Button } from 'js/components/common/Button';
import * as hooks from '@core/js/components/main/DefaultHeader/hooks';
import { MyAccount } from '@core/js/components/main/DefaultHeader/components//MyAccount';
import { MyBalance } from '@core/js/components/main/DefaultHeader/components//MyBalance';
import { AdditionalUserInfo } from '@core/js/components/main/DefaultHeader/components//AdditionalUserInfo';

import style from './MobileHeader.scss';

export const MobileHeader: React.FC = () => {
    const translate = useComponentTranslations();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const onLoginButtonClick = hooks.useOnLoginButtonClick();
    const { registrationURL } = useAppSelector(pick(['registrationURL'])); /* Omni changes */
    const { overrideMenu, menuWcId } = usePageSelector(pick(['overrideMenu', 'menuWcId']));
    const hideSideMenuIcon = overrideMenu && !menuWcId;
    const openSideMenu = useCallback(() => dispatcher.dispatch('menu:action:open'), []);
    const { isShowBackButton, handleBackButtonClick } = hooks.useBackButton();

    return (
        <>
            <div className={style.header}>
                <div className={style.info}>
                    {!hideSideMenuIcon && !isShowBackButton && (
                        <Icon
                            type="sideMenu"
                            onClick={openSideMenu}
                            className={`${style.menu} cms-icon-side-menu`}
                            aria-label={translate('header.sideMenu.aria-label')}
                        />
                    )}
                    {isShowBackButton && (
                        <Icon
                            type="backButton"
                            onClick={handleBackButtonClick}
                            className="cms-icon-back-button"
                            aria-label={translate('header.backBtn')}
                        />
                    )}
                    <Logo />
                </div>
                <div className={style.controls}>
                    {isLoggedIn
                        ? (
                            <>
                                <MyBalance />
                                <MyAccount />
                            </>
                        )
                        : (
                            <>
                                {/* Omni changes */}
                                <Button
                                    size="small"
                                    color="success"
                                    view="secondary"
                                    className={style.login}
                                    onClick={onLoginButtonClick}
                                >
                                    {translate('login.button.loginHeader')}
                                </Button>
                                {registrationURL && (
                                    <Button
                                        size="small"
                                        color="revert"
                                        view="secondary"
                                        href={registrationURL}
                                        className={style.register}
                                    >
                                        {translate('login.button.join_now')}
                                    </Button>
                                )}
                                {/* Omni changes */}
                            </>
                        )
                    }
                </div>
            </div>
            <AdditionalUserInfo />
        </>
    );
};
